/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import {
  IcoMoon,
  ChatWithUsWmoIcon,
  EmailUsWmoIcon,
  HelpCenterWmoIcon,
  EllipseWmoIcon,
  useResponsiveWrapperContext,
} from '@usap/uicomponents'
import {
  StyledButton,
  StyledButtonText,
  MaskedGroup,
  MaskedImage,
  StyledButtonContainer,
  StyledContactUsContainer,
  StyledHelpBox,
  StyledLinks,
  StyledQuestionContainer,
  StyledQuestionText,
} from './SupportBarWmo.css'

const SupportBarWmo = ({ openChat, isNotFound=false }) => {
  const { isDesktop } = useResponsiveWrapperContext()

  return (
    <StyledHelpBox>
      <StyledContactUsContainer gap="12px">
        <StyledQuestionContainer gap="12px">
          <MaskedGroup>
            <IcoMoon
              icon={EllipseWmoIcon}
              size={isDesktop ? '48px' : '40px'}
            />
            <MaskedImage isNotFound={isNotFound}/>
          </MaskedGroup>
          <StyledQuestionText color="#282832" fontSize="18px" height="28px">
            Have a Question? We're Here to Help!
          </StyledQuestionText>
        </StyledQuestionContainer>
        <StyledButtonContainer gap="8px">
          <StyledButton color="#FFCD05" onClick={openChat}>
            <IcoMoon icon={ChatWithUsWmoIcon} />
            <StyledButtonText color="#282832">
              {isDesktop ? 'Chat With Us' : 'Chat'}
            </StyledButtonText>
          </StyledButton>
          <StyledButton color="#282832">
            <IcoMoon icon={EmailUsWmoIcon} />
            <StyledLinks color="#fff" href="/help-center/contact-us">
              {isDesktop ? 'Email Us' : 'Email'}
            </StyledLinks>
          </StyledButton>
          <StyledButton color="#FFF" border="1px">
            <IcoMoon icon={HelpCenterWmoIcon} />
            <StyledLinks color="#3E3E47" href="/help-center" target='_self'>
              {isDesktop ? 'Help Center' : 'Help'}
            </StyledLinks>
          </StyledButton>
        </StyledButtonContainer>
      </StyledContactUsContainer>
    </StyledHelpBox>
  )
}

export default SupportBarWmo
